module.exports = __webpack_public_path__ + "img/basic-send.1e0bcd81.svg";